import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { useBreadcrumbs } from '~/composables/useBreadcrumbs';

export default defineNuxtRouteMiddleware(() => {
  const { setBreadcrumbs } = useBreadcrumbs();
  setBreadcrumbs([
    {
      text: 'ダイエットQ&A',
    },
  ]);
});
